<script lang="ts" setup>
import BrandList from "@/components/layouts/topBar/BrandList.vue";
import LanguageDropDown from "@/components/layouts/topBar/LanguageDropDown.vue";
import Cart from "@/components/layouts/topBar/Cart.vue";
import SiteMode from "@/components/layouts/topBar/SiteMode.vue";
import ScreenSize from "@/components/layouts/topBar/ScreenSize.vue";
import Profile from "@/components/layouts/topBar/Profile.vue";
import MenuComponents from "@/components/layouts/topBar/MenuComponent.vue";
import MobileMenuComponent from "@/components/layouts/topBar/MobileMenuComponent.vue";

import { useLayoutStore } from "@/store/app";
import { SIDEBAR_SIZE, LAYOUTS, LAYOUT_POSITION } from "@/app/const";
import { onMounted, onUnmounted, computed, ref, watch } from "vue";

const { SMALL, DEFAULT } = SIDEBAR_SIZE;

const state = useLayoutStore();
const search = ref("");
const isSmallMenuActive = ref(false);

const sideBarSize = computed(() => {
  return state.sideBarSize;
});

const isSmallSideBar = computed(() => {
  return sideBarSize.value === SMALL;
});

const isHorizontal = computed(() => {
  return state.layoutType === LAYOUTS.HORIZONTAL;
});

const isScrollableLayout = computed(() => {
  return state.position === LAYOUT_POSITION.SCROLLABLE;
});

onMounted(() => {
  addEventListeners();
});

const topBarScrollEvent = () => {
  var pageTopBar = document.getElementById("page-topbar");
  if (pageTopBar && !isScrollableLayout.value) {
    document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50
      ? pageTopBar.classList.add("topbar-shadow")
      : pageTopBar.classList.remove("topbar-shadow");
  }
};

const addEventListeners = () => {
  document.addEventListener("scroll", topBarScrollEvent);
};

const onDrawerClick = () => {
  if (isHorizontal.value) {
    isSmallMenuActive.value = !isSmallMenuActive.value;
  }
  // const sideBarSize = state.sideBarSize;
  // if (sideBarSize === SMALL) {
  //   state.changeSideBarSize(DEFAULT);
  // } else {
  //   state.changeSideBarSize(SMALL);
  // }
};

const onMenuClicked = () => {
  if (isHorizontal.value) {
    isSmallMenuActive.value = false;
  }
}

onUnmounted(() => {
  document.removeEventListener("scroll", topBarScrollEvent);
});
</script>
<template>
  <v-app-bar :scroll-behavior="isScrollableLayout ? 'hide elevate' : 'elevate'" class="banner" id="page-topbar"
    height="70">
    <v-container class="layout-width" fluid>
      <div class="navbar-header">
        <div class="d-flex align-center navbar-header-border">
          <div class="navbar-brand-box horizontal-logo">
            <router-link to="/" class="logo logo-dark">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="60" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-caat.png" alt="" height="76" />
              </span>
            </router-link>

            <router-link to="/" class="logo logo-light">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="60" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-caat.png" alt="" height="76" />
              </span>
            </router-link>
          </div>
          <!-- <v-menu class="content-100">
            <template v-slot:activator="{ props }"> -->
          <v-app-bar-nav-icon class="navbar-icon" variant="text" @click.stop="isSmallMenuActive = !isSmallMenuActive">
          </v-app-bar-nav-icon>
          <!-- <v-avatar rounded="lg" size="36">
              <v-img src="@/assets/images/logo-sm.png" />
            </v-avatar> -->
          <!-- <v-icon icon="mdi mdi-close"></v-icon> -->

          <!-- </template> -->

          <!-- </v-menu> -->
        </div>

        <router-link v-if="$vuetify.display.xs" to="/" class="logo">
          <span class="logo-lg">
            <img src="@/assets/images/logo-caat.png" alt="" height="56" />
          </span>
        </router-link>

        <div v-if="isHorizontal && $vuetify.display.mdAndUp" class="d-flex navbar-header-main">
          <MenuComponents />
        </div>
        <div class="navbar-header-border">
          <div class="dropdown topbar-head-dropdown ms-1 header-item">
            <LanguageDropDown />
            <!-- <ScreenSize />
            <Notifications /> -->
            <div class="topbar-head-box-profile">
              <Profile />
            </div>
          </div>
        </div>
      </div>
      <div v-if="isHorizontal && $vuetify.display.sm" class="navbar-menu-horizontal">
        <!-- <v-divider class="topbar-divider" /> -->
        <MenuComponents />
      </div>
    </v-container>
  </v-app-bar>
  <v-navigation-drawer v-model="isSmallMenuActive" :location="$vuetify.display.mobile ? 'top' : undefined" temporary
    :class="isSmallMenuActive ? 'mobile-menu-active' : 'mobile-menu-inactive'">
    <MobileMenuComponent v-if="isHorizontal && $vuetify.display.xs" @on-menu-clicked="onMenuClicked" />
  </v-navigation-drawer>
</template>